import React,{useState, useEffect} from 'react';
import { withRouter,Redirect, Link, useParams, Navigate} from "react-router-dom";
import './GetDevice.scss';
import axios from 'axios';
import * as dataDevice from "../../Data/MyDevice.json";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';
import ReactLoading from 'react-loading';

export const GetDevice = (props) => {
  const { lang } = useParams();
  const [devices, setDevices] = useState([]);
  const [versionPhysio, setVersionPhysio] = useState({});
  const [versionPro, setVersionPro] = useState({});
  const [versionProConnect, setVersionProConnect] = useState({});
  const [loading, setLoading] = useState(true);
  // Textes traduits (fr / en / es) — le composant n en avait pas : il ne rendait
  // que des cartes d appareil, jamais de message.
  const data = dataDevice.default[lang] || dataDevice.default["en"];

  let auth = JSON.parse(sessionStorage.getItem('userData'));

  const user_id = auth.user_id;
  const hostName = "/Back-end/getDevice";

  useEffect(() => {
    // Fonction d'exécution des requêtes
    const executerRequetes = async () => {
      try {
        // Requête pour obtenir les devices
        const deviceResponse = await axios.get(`${hostName}/${user_id}`);
        const devices = deviceResponse.data;

        console.log(deviceResponse);

        // Requêtes pour obtenir les versions
        const versionPhysioResponse = await axios.get('/Back-end/getVersion/PHYSIO');
        const versionProResponse = await axios.get('/Back-end/getVersion/PRO');
        // Repli explicite : une erreur ici ferait sortir du try, donc setLoading(false)
        // ne serait jamais atteint et la page resterait bloquée sur le chargement.
        const versionProConnectResponse = await axios
          .get('/Back-end/getVersion/PROCONNECT')
          .catch(() => ({ data: {} }));

        // Mise à jour des états locaux
        setDevices(devices);
        setVersionPhysio(versionPhysioResponse.data);
        setVersionPro(versionProResponse.data);
        setVersionProConnect(versionProConnectResponse.data);

        setLoading(false); // Désactiver le chargement
      } catch (error) {
        console.error('Erreur lors des requêtes:', error);
        // Sans ceci, un echec de getDevices ou de getVersion PHYSIO/PRO laissait
        // la page bloquee indefiniment sur l ecran de chargement.
        setLoading(false);
      }
    };

    // Exécuter les requêtes une seule fois au chargement du composant
    executerRequetes();
  }, [user_id]); // Dépendance sur user_id pour n'exécuter qu'une fois

  const handleDelete = async (dev_id) => {
    try {
      // Supprimer l'appareil
      const response = await axios.post('/Back-end/RequestdeleteDevice', { id: dev_id });
      console.log(response);
      // Mettre à jour l'état local en filtrant l'appareil supprimé
      setDevices(devices.filter((device) => device.dev_id !== dev_id));
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'appareil:', error);
    }
  };

  if (loading) {
    return <ReactLoading type="bars" color="#15acf2" height={667} width={375} />;
  }

  // 185 comptes (dont 125 kinesitherapeutes) n ont aucun appareil rattache.
  // Sans ce bloc, devices.map sur un tableau vide ne rendait RIEN : ils
  // arrivaient sur une zone blanche, sans explication ni action possible.
  if (devices.length === 0) {
    return (
      <div className="emptyDevices">
        <h2 className="emptyDevices__title">{data.empty.title}</h2>
        <p className="emptyDevices__text">{data.empty.text}</p>
        <div className="emptyDevices__actions">
          <Link to={`/${lang}/MyDevice`} className="emptyDevices__cta">{data.empty.add}</Link>
          <Link to={`/${lang}/HomeAcademy`} className="emptyDevices__link">{data.empty.discover}</Link>
        </div>
        <p className="emptyDevices__help">{data.empty.help}</p>
      </div>
    );
  }

  return (
    <>
      {
        devices.map((device) => {
        let upToDate = false;
        
        if(device.name === "PHYSIO") {
          upToDate = versionPhysio.ihm === device.interface && versionPhysio.core === device.core;

          return (
            <Device
              lang={lang}
              key={device.dev_id}
              device={device}
              upToDate={upToDate}
              handleDelete={handleDelete}
              />
          );
        }
        if(device.name === "PRO") {
          upToDate = versionPro.ihm === device.interface && versionPro.core === device.core;

          return (
            <DevicePro
              lang={lang}
              key={device.dev_id}
              device={device}
              upToDate={upToDate}
              handleDelete={handleDelete}
              />
          );
        }

        // Pro connect : meme carte que le PHYSIO, dont il reprend l interface et
        // la forme du numero de serie. Sans cette branche l appareil existait en
        // base mais ne produisait aucune carte : il restait simplement invisible.
        if(device.name === "PROCONNECT") {
          upToDate = versionProConnect.ihm === device.interface && versionProConnect.core === device.core;

          return (
            <Device
              lang={lang}
              key={device.dev_id}
              device={device}
              upToDate={upToDate}
              handleDelete={handleDelete}
              // converti mais module coeur pas encore flashe : l'appareil est
              // reste a l'etape 2 et n'est pas utilisable. On lui affiche la
              // procedure complete plutot que de le laisser sans issue.
              //
              // On ne conclut QUE si la version de reference est reellement connue.
              // Sinon (API en echec -> repli {}), versionProConnect.core valait
              // undefined et la comparaison etait toujours vraie : tout Pro connect
              // en bon etat affichait « cet appareil ne peut pas etre utilise ».
              step2={Boolean(versionProConnect.core) && versionProConnect.core !== device.core}
              />
          );
        }

        return null;
      })}
    </>

    )
};

// step2 : vrai uniquement pour un Pro connect dont le module coeur n'est pas
// encore a jour, c'est-a-dire converti mais reste a l'etape 2. Le PHYSIO
// n'envoie jamais cette prop, sa carte est donc inchangee.
const Device=({lang, device, upToDate, handleDelete, step2})=>{
  const [basicModal, setBasicModal] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);
  const [data, setData] = useState(dataDevice.default[lang]);

  const goToolBox = () => {
    sessionStorage.setItem('deviceID',JSON.stringify(device.dev_id))
    // Pro connect partage la mise en page de la carte PHYSIO, mais son materiel
    // est un PRO : la boite a outils suit le materiel. Choix produit du 4 aout 2026.
    window.location.href = device.name === "PROCONNECT"
      ? `/${lang}/ToolboxPro`
      : `/${lang}/ToolboxPhysio`
  }

  return (
    <section className='displayDevice'>
      <div className="imgDev">
        {/* Un Pro connect est physiquement un PRO : on montre le boitier PRO,
            meme si la carte reprend par ailleurs la mise en page du PHYSIO. */}
        <img src={device.name === "PROCONNECT"
                    ? "https://mad-up.com/api/uploads/mad-up/originals/imgDispo.png"
                    : "https://mad-up.com/api/uploads/mad-up/originals/imgDispoPhysio.png"}
             alt="Device" />
      </div>
      <div className='content'>
        <p className='pinfo'>{device.name === "PROCONNECT" ? "PRO connect" : device.name}</p>
        <hr />
        <p className='pinfo'>{data.device.numSerial} {device.serial_num}</p>
        <hr />
        <p className='pinfo'>{data.device.codeAct} {device.code}</p>
        <hr />
        <p className='pinfo'>
          <div className="buttonExtended color" onClick={goToolBox}>
            <span className="hyphen"></span>
            <div className="buttonExtended_text ligne-texte-icone">
              <span className="texte">{data.device.info}</span>
              {!upToDate && (
                <i className="fa-regular fa-2x fa-bell squizz"></i>
              )}
            </div>
          </div>

          <div className="buttonExtended color" onClick={() => window.open(data.device.link, '_blank')}>
            <span className="hyphen"></span>
            <div className="buttonExtended_text ligne-texte-icone">
              <span className="texte">{data.device.sav}</span>
            </div>
          </div>
        </p>
        {step2 && data.device.step2Title && (
          <div style={{
            margin: "6px 0 2px", padding: "14px 16px", borderRadius: "10px",
            background: "#fff6e8", borderLeft: "4px solid #F5A623", textAlign: "left"
          }}>
            <p style={{ margin: 0, fontWeight: 700, color: "#7a4c05" }}>
              <i className="fa-regular fa-circle-exclamation" style={{ marginRight: "8px" }}></i>
              {data.device.step2Title}
            </p>
            <p style={{ margin: "6px 0 0", color: "#334", fontSize: "0.92em", lineHeight: 1.45 }}>
              {data.device.step2Intro}
            </p>
            <p style={{ margin: "6px 0 0", color: "#7a4c05", fontSize: "0.92em", fontWeight: 600, lineHeight: 1.45 }}>
              {data.device.step2Warning}
            </p>

            <p style={{ margin: "12px 0 4px", fontWeight: 700, color: "#0b5875", fontSize: "0.95em" }}>
              {data.device.step2StepsTitle}
            </p>
            <ol style={{ margin: 0, paddingLeft: "20px", color: "#334", fontSize: "0.9em", lineHeight: 1.5 }}>
              {(data.device.step2Steps || []).map((etape, i) => (
                <li key={i} style={{ marginBottom: "5px" }}>{etape}</li>
              ))}
            </ol>

            <div style={{ marginTop: "12px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
              <a href={data.device.step2DownloadLink}
                 style={{
                   background: "#00AEEF", color: "#fff", padding: "9px 14px",
                   borderRadius: "8px", textDecoration: "none", fontWeight: 600, fontSize: "0.9em"
                 }}>
                <i className="fa-regular fa-download" style={{ marginRight: "7px" }}></i>
                {data.device.step2Download}
              </a>
              <a href={data.device.step2GuideLink} target="_blank" rel="noopener noreferrer"
                 style={{
                   background: "#fff", color: "#0b5875", border: "1px solid #bcd9e6",
                   padding: "9px 14px", borderRadius: "8px", textDecoration: "none",
                   fontWeight: 600, fontSize: "0.9em"
                 }}>
                {data.device.step2Guide}
              </a>
              <a href={data.device.link} target="_blank" rel="noopener noreferrer"
                 style={{
                   background: "#fff", color: "#0b5875", border: "1px solid #bcd9e6",
                   padding: "9px 14px", borderRadius: "8px", textDecoration: "none",
                   fontWeight: 600, fontSize: "0.9em"
                 }}>
                {data.device.step2Support}
              </a>
            </div>
            <p style={{ margin: "8px 0 0", color: "#556", fontSize: "0.85em", lineHeight: 1.4 }}>
              {data.device.step2Help}
            </p>
          </div>
        )}
        <hr />
      </div>
      <div className="imgTrash">
        <i className="fa-regular fa-2x fa-trash-can" onClick={toggleShow}></i>
      </div>

      {/* Modal de confirmation de suppression */}
      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader style={{ border: "none" }}>
              <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody style={{ textAlign: "center" }}>
            {data.device.msg}
            </MDBModalBody>
            <MDBModalFooter style={{ border: "none" }}>
              <MDBBtn style={{ background: "#DC3535" }} onClick={toggleShow}>{data.device.close}</MDBBtn>
              <MDBBtn style={{ background: "#15acf2" }} onClick={() => handleDelete(device.dev_id)}>{data.device.reponse}</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </section>
  );
};

const DevicePro=({lang, device, upToDate, handleDelete, handleSAV})=>{
  const [basicModal, setBasicModal] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);
  const [data, setData] = useState(dataDevice.default[lang]);

  const goToolBox = () => {
    sessionStorage.setItem('deviceID',JSON.stringify(device.dev_id))
    window.location.href=`/${lang}/ToolboxPro`
  }

  return (
    <section className='displayDevice'>
      <div className="imgDev">
        <img src="https://mad-up.com/api/uploads/mad-up/originals/imgDispo.png" alt="Device" />
      </div>
      <div className='content'>
        <p className='pinfo'>{device.name}</p>
        <hr />
        <p className='pinfo'>{data.device.numSerial} {device.serial_num}</p>
        <hr />
        <p className='pinfo'>{data.device.codeAct} {device.code}</p>
        <hr />
        <p className='pinfo'>
          <div className="buttonExtended color" onClick={goToolBox}>
            <span className="hyphen"></span>
            <div className="buttonExtended_text ligne-texte-icone">
              <span className="texte">{data.device.info}</span>
              {!upToDate && (
                <i className="fa-regular fa-2x fa-bell squizz"></i>
              )}
            </div>
          </div> {/* window.open('https://forms.office.com/r/4MWeCBrWZA', '_blank') */}
          <div className="buttonExtended color" onClick={() => window.open(data.device.link, '_blank')}>
            <span className="hyphen"></span>
            <div className="buttonExtended_text ligne-texte-icone">
              <span className="texte">{data.device.sav}</span>
            </div>
          </div>
        </p>
        {!upToDate && data.device.updateNotePro && (
          <div style={{
            margin: "6px 0 2px", padding: "12px 14px", borderRadius: "10px",
            background: "#eef7fb", borderLeft: "4px solid #00AEEF", textAlign: "left"
          }}>
            <p style={{ margin: 0, fontWeight: 700, color: "#0b5875" }}>
              <i className="fa-regular fa-bell" style={{ marginRight: "8px" }}></i>
              {data.device.updateTitle}
            </p>
            <p style={{ margin: "4px 0 0", color: "#334", fontSize: "0.92em", lineHeight: 1.45 }}>
              {data.device.updateNotePro}
            </p>
          </div>
        )}
        <hr />
      </div>
      <div className="imgTrash">
        <i className="fa-regular fa-2x fa-trash-can" onClick={toggleShow}></i>
      </div>

      {/* Modal de confirmation de suppression */}
      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader style={{ border: "none" }}>
              <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody style={{ textAlign: "center" }}>
            {data.device.msg}
            </MDBModalBody>
            <MDBModalFooter style={{ border: "none" }}>
              <MDBBtn style={{ background: "#DC3535" }} onClick={toggleShow}>{data.device.close}</MDBBtn>
              <MDBBtn style={{ background: "#15acf2" }} onClick={() => handleDelete(device.dev_id)}>{data.device.reponse}</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </section>
  );
}

export default GetDevice;